/**
 * Asynchronous function constructor.
 */
export const AsyncFunction = async function () {}.constructor;
